import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const FractionalCtaSection = () => (
    <section id="cta" className="lp-cta">
        <div className="lp-cta-card" data-lp-reveal>
            <div className="lp-cta-glow" aria-hidden="true" />
            <div className="lp-cta-inner">
                <h2>Become indispensable.</h2>
                <p className="sub">Free advisor account. 30-minute call. No preparation needed.</p>
                <a className="lp-cta-btn" href={KOALENDAR} target="_blank" rel="noopener noreferrer">
                    <span className="av"><img src={require('../../../../images/fractional/testimonial/centerTestimonial.svg')} alt="" /></span>
                    Book a call
                </a>
            </div>
        </div>
    </section>
);

export default FractionalCtaSection;
